import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// The simplest possible model: one variant, no animation. A good file to copy
// when starting a new static prop — just `defineModel` with a `parts()`.
const WOOD = "#8a5a2b";
const HOOP = "#3b3b40";

export const barrel = defineModel({
  id: "barrel",
  batchId: "standard",
  name: "Barrel",
  tags: ["prop", "container", "wood"],
  summary: "A hooped wooden barrel.",
  footprint: 0.22,
  parts(): Part[] {
    return [
      { geometry: new THREE.CylinderGeometry(0.18, 0.15, 0.42, 12), color: WOOD, position: [0, 0.21, 0] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.2, 0.04, 12), color: WOOD, position: [0, 0.21, 0] },
      { geometry: new THREE.CylinderGeometry(0.185, 0.185, 0.03, 12), color: HOOP, position: [0, 0.08, 0] },
      { geometry: new THREE.CylinderGeometry(0.185, 0.185, 0.03, 12), color: HOOP, position: [0, 0.34, 0] },
    ];
  },
  animations: [],
});
